import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "14px",
	height: "18px",
	viewBox: "0 0 14 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Icon" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Web-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Desktop---Dark---todos---reminder01",
				transform: "translate(-1259.000000, -373.000000)",
				fill: "#7A7A7A",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-11",
					transform: "translate(1239.000000, 228.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M24.6448493,147.103987 L24.6448493,146.635655 C24.6448493,146.378501 24.9047554,146.168882 25.2238019,146.168882 L28.4726285,146.168882 C28.7924531,146.168882 29.0523592,146.378501 29.0523592,146.635655 L29.0523592,147.103987 L24.6448493,147.103987 Z M31.6817688,148.27209 C31.6140687,150.037101 31.1946393,160.851595 31.1417243,161.338629 C31.1105978,161.630071 31.0032115,161.773453 30.9456275,161.831118 L22.7508029,161.831118 C22.6924407,161.773453 22.5858325,161.630071 22.554706,161.338629 C22.5025692,160.851595 22.0333375,150.044894 21.9570776,148.27209 L31.6817688,148.27209 Z M28.5885746,145 C29.4857955,145 30.2149333,145.733278 30.2149333,146.635655 L30.2149333,146.635655 L30.2149333,147.103987 L33.6956522,147.103987 L33.6956522,148.27209 L32.873913,148.27209 L32.3035203,161.72514 C32.287957,161.813195 32.0288291,163 31.025,163 L31.025,163 L22.669874,163 C21.6668231,163 21.4076952,161.813195 21.3975791,161.763323 L21.3975791,161.763323 L20.7937253,148.27209 L20,148.27209 L20,147.103987 L23.481497,147.103987 L23.481497,146.635655 C23.481497,145.733278 24.2106349,145 25.1078557,145 L25.1078557,145 Z M29.9781491,149.20813 L28.8147968,149.20813 L28.4521733,160.896169 L29.6155256,160.896169 L29.9781491,149.20813 Z M27.4293466,149.208286 L26.2659943,149.208286 L26.2659943,160.896325 L27.4293466,160.896325 L27.4293466,149.208286 Z M24.8807436,149.20813 L23.7173913,149.20813 L24.0792367,160.896169 L25.2433671,160.896169 L24.8807436,149.20813 Z",
						id: "Icon"
					})
				})
			})
		})
	]
});
export default SvgDelete;
